// firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC7dJO2fIMNp18d8OGZlW9GtFWio98z7FY",
  authDomain: "pantheon-38868.firebaseapp.com",
  projectId: "pantheon-38868",
  storageBucket: "pantheon-38868.firebasestorage.app",
  messagingSenderId: "852526011536",
  appId: "1:852526011536:web:17247d3054817bd992f415",
  measurementId: "G-X9BCKRQXEQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore and Auth services
const db = getFirestore(app);
const auth = getAuth(app);

export { app, db, auth };
